import { Controller } from '@hotwired/stimulus';
import validate from '../../modules/validate';

export default class extends Controller {
  connect () {
    validate();
  }
}
